import { Box } from "@chakra-ui/react";
import React, { useContext, useLayoutEffect, useRef, useState, } from "react";
import { DisplayLayoutItem } from "./LayoutItem/DisplayLayoutItem";
import { StudioContext } from "./studioContext";
export const Player = ({ playerWidth, playerHeight }) => {
    const { layoutItems, selectedLayoutItemId, screenHeight, screenWidth, isLocked, widgets, setAnimationsModalOpened, showAnimations, } = useContext(StudioContext);
    const ref = useRef(null);
    const [itemsContainer, setItemsContainer] = useState(null);
    const [playerSize, setPlayerSize] = useState({
        width: 0,
        height: 0,
        marginLeft: 0,
    });
    useLayoutEffect(() => {
        setItemsContainer(ref.current);
    }, []);
    useLayoutEffect(() => {
        if (screenWidth > screenHeight) {
            setPlayerSize({
                width: playerWidth,
                height: playerWidth * (screenHeight / screenWidth),
                marginLeft: 0,
            });
        }
        else {
            setPlayerSize({
                width: playerHeight * (screenWidth / screenHeight),
                height: playerHeight,
                marginLeft: (playerWidth - playerHeight * (screenWidth / screenHeight)) / 2,
            });
        }
    }, [playerWidth, playerHeight, screenWidth, screenHeight]);
    const scale = playerSize.width / screenWidth;
    const selectedLayoutItemD = selectedLayoutItemId;
    return (React.createElement(Box, { "data-testid": "player-testi-d", id: "studio-preview", width: screenWidth, height: screenHeight, bg: "black", borderRadius: `${8 / scale}px`, ref: ref, marginLeft: playerSize.marginLeft + "px", transform: `scale(${scale})`, position: "relative", transformOrigin: "left top" }, itemsContainer &&
        layoutItems.map((layoutItem, index) => {
            return (React.createElement(Box, { "data-testid": "player-item-test-id", key: `display-layout-item-${index}` },
                React.createElement(DisplayLayoutItem, { layoutItems: layoutItems, index: index, layoutItem: layoutItem, scale: scale, isLocked: isLocked, screenHeight: screenHeight, screenWidth: screenWidth, widgets: widgets, isSelected: selectedLayoutItemD === layoutItem.id, setAnimationsModalOpened: setAnimationsModalOpened, showAnimations: showAnimations })));
        })));
};
